import DOMPurify from "isomorphic-dompurify";

export type SafeHtmlString = string & { readonly __brand: "SafeHtmlString" };

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.hasAttribute("target")) {
    node.setAttribute("rel", "noopener noreferrer");
  }
});

export function sanitizeHtml(html: string): SafeHtmlString {
  return DOMPurify.sanitize(html, { ADD_ATTR: ["target", "rel"] }) as SafeHtmlString;
}
